import { cellAt } from './artwork'
import { sample } from './lib/math'
import { allAutomaton } from './preset-rules'
import { generateRandomAutomataRules } from './rules'
import { AutomatonRule, Cell, CellKind, GlobalState } from './types'

export const state = {
  rules: getRandomRulesSet()
}

setInterval(() => {
  state.rules = getRandomRulesSet()
}, 24000)

setInterval(() => {
  // mutatePalette()
}, 12000)

export function getRandomRulesSet() {
  if (Math.random() > 0.5) {
    const randomRules = generateRandomAutomataRules()
    console.log(`Random automaton, ${randomRules.length} rules`)
    return randomRules
  }

  const sampled = sample(allAutomaton)!
  console.log(
    `Automaton preset "${sampled.name}", ${sampled.rules.length} rules`
  )
  return sampled.rules
}

export function oneAutomataStep(globalState: GlobalState): {
  output: Cell[]
  changedCellKinds: number
} {
  const input = globalState.grid
  const output: Cell[] = []
  const { rows, columns } = globalState.display
  let changedCellKinds = 0
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < columns; x++) {
      const nextCellKind = calculateNextCellAutomataKind(
        x,
        y,
        input,
        rows,
        columns,
        state.rules
      )

      const cellIndex = getCellIndex(x, y, columns)
      if (nextCellKind !== input[cellIndex].kind) {
        globalState.animation[cellIndex].age = 0
        changedCellKinds++
      }

      output[cellIndex] =
        Math.random() > 0.5
          ? input[cellIndex]
          : {
              kind: nextCellKind,
              group: null
            }
    }
  }
  return { output, changedCellKinds }
}

function getCellIndex(x: number, y: number, columns: number): number {
  return x + y * columns
}

export function calculateNextCellAutomataKind(
  x: number,
  y: number,
  input: Cell[],
  rows: number,
  columns: number,
  rules: AutomatonRule[]
): CellKind {
  const kind = cellAt(input, x, y, columns, rows).kind

  function c(x: number, y: number): CellKind {
    return cellAt(input, x, y, columns, rows).kind
  }

  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i]
    let conditionsMet = true
    for (
      let conditionIndex = 0;
      conditionIndex < rule.conditions.length;
      conditionIndex++
    ) {
      const condition = rule.conditions[conditionIndex]
      const neighbour = c(x + condition.n[0], y + condition.n[1])
      conditionsMet = conditionsMet && neighbour === condition.value
    }
    if (conditionsMet) {
      return rule.result
    }
  }

  return kind
}
